// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"ed674c72","280":"ed674c72","295":"fda40e9c","299":"d75c0140","333":"f4617ed6","412":"14effda7","498":"ecce74cd","506":"7722e06b","716":"4b67c3dd","757":"fdae4de7","945":"448bda36","985":"ed674c72"}[chunkId] + ".chunk.css";
};